<template>
  <div
    class="sticky bottom-[calc(10px+env(safe-area-inset-bottom,0px))] z-[5] flex flex-wrap items-center gap-x-3 gap-y-2 rounded-[10px] bg-textPrimary px-3.5 py-2.5 text-white shadow-lg"
    :data-testid="testId"
  >
    <b v-if="selectedCount > 0" :data-testid="`${testId}-selected`">{{ selectedLabel }}</b>
    <span v-else :data-testid="`${testId}-pending`">
      <b>{{ pendingCount }}</b> {{ pendingLabel }} neste filtro
    </span>

    <span class="flex-1" />

    <button
      type="button"
      class="rounded-md border border-primary bg-primary px-3 py-1.5 text-sm font-medium text-white"
      :data-testid="`${testId}-primary`"
      @click="emit('primary')"
    >
      {{ primaryLabel }}
    </button>

    <template v-if="selectedCount > 0">
      <button
        v-for="action in actions"
        :key="action.key"
        type="button"
        class="rounded-md border border-neutral50 bg-transparent px-3 py-1.5 text-sm font-medium text-white"
        :data-testid="`${testId}-action-${action.key}`"
        @click="emit('action', action.key)"
      >
        {{ action.label }}
      </button>
      <button
        type="button"
        class="rounded-md border border-neutral50 bg-transparent px-3 py-1.5 text-sm font-medium text-white"
        :data-testid="`${testId}-clear`"
        @click="emit('clear')"
      >
        {{ clearLabel }}
      </button>
    </template>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type { QueueBulkAction } from './types'

const props = withDefaults(
  defineProps<{
    selectedCount: number
    pendingCount: number
    /** Complemento de "N ___ neste filtro", ex.: `'precisam de envio'`. */
    pendingLabel: string
    primaryLabel: string
    actions?: QueueBulkAction[]
    clearLabel?: string
    testId?: string
  }>(),
  { actions: () => [], clearLabel: 'Limpar', testId: 'queue-bulk-bar' }
)

const emit = defineEmits<{ primary: []; action: [key: string]; clear: [] }>()

const selectedLabel = computed(
  () => `${props.selectedCount} ${props.selectedCount > 1 ? 'selecionados' : 'selecionado'}`
)
</script>
